import { Pipe, PipeTransform } from '@angular/core';
import { Select } from '@ngxs/store';
import { isObservable, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { formatBytes } from 'src/app/helper/byteFormattingHelper';
import { LanguageType } from 'src/app/samwebDescription/samweb/settings/language-types';
import { SettingsState } from 'src/app/store/settings/settings.state';

@Pipe({
   name: 'formatBytes',
})
export class FormatBytesPipe implements PipeTransform {
   @Select(SettingsState.getCurrentLanguage)
   private languageType$: Observable<LanguageType>;

   transform(iconNameValue: number | Observable<number>): Observable<string> {
      let bytes$: Observable<number>;
      if (isObservable(iconNameValue)) {
         bytes$ = iconNameValue as Observable<number>;
      } else {
         bytes$ = of(iconNameValue);
      }

      const result = bytes$.pipe(
         switchMap((bytes: number) => this.languageType$.pipe(map((language) => formatBytes(bytes, 2, language.angularTranslationKey))))
      );
      return result;
   }
}
